import { render } from "./AdminLogo.vue?vue&type=template&id=2942e050&scoped=true"
import script from "./AdminLogo.vue?vue&type=script&lang=js"
export * from "./AdminLogo.vue?vue&type=script&lang=js"

import "./AdminLogo.vue?vue&type=style&index=0&id=2942e050&lang=scss&scoped=true"

import exportComponent from "/Users/dmytrokulyk/Documents/Development/GreenHub/dsp-f-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2942e050"]])

export default __exports__